import React from 'react';
import PropTypes from 'prop-types';

const Navigation = ({ items, classes, linkClass }) => {
  return (
    <ul className={`flex flex-col gap-2 pb-6 ${classes}`}>
      {items.map(({ label, href, Icon }, index) => (
        <li key={index}>
          <a href={href} className={`flex flex-row py-[10px] pl-3 items-center group text-gray-400 hover:text-gold-500 ${linkClass}`}>
            <div className="pr-3">
              <Icon className="" />
            </div>
            <p className="text-sm font-medium leading-4.5">
              {label}
            </p>
          </a>
        </li>
      ))}
    </ul>
  );
};

// Prop validation
Navigation.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            href: PropTypes.string.isRequired,
            Icon: PropTypes.elementType.isRequired, // Component for the icon
        })
    ).isRequired,
};

export default Navigation;